module.exports = __webpack_public_path__ + "img/dept-6.f2a4da40.svg";